import { Injectable } from '@angular/core';

import { BasePostProvider } from '@tendercuts/http';
import { GenericServerResponse } from '@tendercuts/models';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EndPoint } from '@endpoint';
import { LoginServices } from '@login';

@Injectable()
export class FreshdeskTicketCreateService extends BasePostProvider<
GenericServerResponse
> {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint,
  ) {
    super(http);
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  // As its an form data we pass content type as undefined
  get contentType(): any {
    return undefined;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get endpoint(): string {
    return this.endpointService.freshDeskTicketsCreate();
  }

  get model(): typeof GenericServerResponse {
    return GenericServerResponse;
  }
}
